//BFSG
import { Order } from 'hooks/account/types'
import useTranslations from 'hooks/useTranslations'
import * as React from 'react'
import styled, { css } from 'styled-components'
import theme from 'theme'
import Button from 'theme/atoms/Button'
import { Icon } from 'theme/atoms/Button'

type Props = {
  totalItems: number
  label: string
  link: string
  icon?: Icon
  order?: Order
  orderNotOlderThan24Hours: boolean
  'aria-label'?: string
}

export default function OrderButton(props: Props) {
  const t = useTranslations<'molecules-account-Minicart'>()
  if (
    props.order &&
    props.order.paymentNecessary &&
    props.orderNotOlderThan24Hours
  ) {
    return (
      <Wrapper className="OrderButton" $showIndicator={props.totalItems > 4}>
        <div className="blur">
          <div className="floating">+{props.totalItems - 3}</div>
        </div>
        <Button
          variation="delete"
          icon={props.icon}
          to={'/checkout/failure?order=' + props.order.orderNumber}
          aria-label={t.asText(false, 'orderbutton_to_payment')}
        >
          {t('orderbutton_to_payment')}
        </Button>
      </Wrapper>
    )
  }
  return (
    <Wrapper className="OrderButton" $showIndicator={props.totalItems > 4}>
      <div className="blur">
        <div className="floating">+{props.totalItems - 3}</div>
      </div>
      <Button
        variation="primary"
        icon={props.icon}
        to={props.link}
        aria-label={props['aria-label'] || ''}
      >
        {props.label}
      </Button>
    </Wrapper>
  )
}

const Wrapper = styled.div<{ $showIndicator: boolean }>`
  position: absolute;
  left: ${theme.spacing('m')};
  right: ${theme.spacing('m')};
  bottom: ${theme.spacing('m')};
  height: 220px;
  background-image: linear-gradient(transparent, ${theme.colors.shade.b7});
  display: flex;
  align-items: flex-end;
  justify-content: center;

  > .blur {
    position: absolute;
    bottom: 62px;
    left: 50%;
    transform: translateX(-50%);
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: white;
    box-shadow: 0px 2px 9px 0px rgba(0, 0, 0, 0.25);
    ${theme.ty('rc-s', 'bold')}
  }

  > .Button {
    width: 100%;
  }

  @media (min-width: ${theme.ms.MD}px) {
    position: static;
    height: auto;
    > .blur {
      display: none;
    }
    > .Button {
      width: auto;
    }
  }

  ${(p) =>
    !p.$showIndicator &&
    css`
      position: static;
      height: auto;
      > .blur {
        display: none;
      }
      > .Button {
        width: auto;
      }
    `}
`
